import React from 'react';
import Layout from '../../components/Layout';
import GetApp from './GetApp';

const title = 'Get the BestHand app';

function action() {
  return {
    title,
    component: (
      <Layout>
        <GetApp />
      </Layout>
    ),
  };
}

export default action;
